import Button from "./button";

export default class SoundButton extends Button {
    static preload(scene){
    }

    constructor({game, scene}){
        super({
            scene,
            img: 'sound_btn_on',
            imgSecondState: 'sound_btn',
            x: scene.scale.width - 70,
            y: 70,
            text: "",
            textMove: 0,
            scaleX: 0.15,
            scaleY: 0.15
        })
        this.game = game;
    }
    onClick(state) {
        if (state === "DEFAULT") {
            this.game.sound.mute = false;
        } else if (state === "SECOND") {
            this.game.sound.mute = true;
        }
    }
}